import { WalletOutlined } from "@ant-design/icons";
import { useTranslation } from "react-i18next";
import { depositTitleOf } from "../deposits/billDeposit";
import type { CloseDepositChoice } from "./useCloseDeposit";

interface DepositOfflineStripProps {
  deposit: CloseDepositChoice;
  /** Тесен екран — по-дребни кегели и отстъпи. */
  compact: boolean;
  /** Хоризонталният падинг го дава РОДИТЕЛЯТ — подравнен с хедъра на модала. */
  className?: string;
}

/**
 * „Закрий" без интернет със закачен депозит — лента на цяла ширина под
 * хедъра (като лентата на клиента), в цветовете на „Локален режим":
 * депозитът е зачертан, а текстът казва, че касата не го приспада —
 * сметката се плаща изцяло, депозитът остава свободен. Методите под нея са
 * обичайните.
 */
export function DepositOfflineStrip({ deposit, compact, className = "" }: DepositOfflineStripProps) {
  const { t } = useTranslation();
  return (
    <div
      className={`flex items-center border-b border-pos-offline-brd bg-pos-offline-bg text-pos-offline-ink ${
        compact ? "gap-2.5 py-1.5" : "gap-3 py-2"
      } ${className}`}
    >
      <span
        className={`inline-flex shrink-0 items-center justify-center rounded-lg border border-pos-offline-brd bg-pos-card ${
          compact ? "size-6 text-[12px]" : "size-7 text-sm"
        }`}
      >
        {/* `!` — `.anticon { color: inherit }` на antd е извън Tailwind layer-ите. */}
        <WalletOutlined className="!text-pos-offline-ink" />
      </span>
      <div className="min-w-0 flex-1">
        <div
          className={`truncate font-extrabold leading-[1.2] line-through ${
            compact ? "text-[13px]" : "text-[15px]"
          }`}
        >
          {depositTitleOf(t, deposit)}
        </div>
        <div className={`font-medium leading-tight ${compact ? "text-[11px]" : "text-xs"}`}>
          {t("closeTable.deposit.offline")}
        </div>
      </div>
    </div>
  );
}
